export default "__VITE_ASSET__BBTi7Q5c__"